import { render, staticRenderFns } from "./monthlyInventory.vue?vue&type=template&id=380adabf&"
import script from "./monthlyInventory.vue?vue&type=script&lang=js&"
export * from "./monthlyInventory.vue?vue&type=script&lang=js&"
import style0 from "./monthlyInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports